import { BaseEntityFieldsArray } from '../../../../models/src';
import { Omit } from '../../../common/src';
import { ErpSyncStatus } from './erp-sync-status.enum';
import { ErpSync } from './erp-sync.entity';

export class CreateErpSyncDto extends Omit(ErpSync, [...BaseEntityFieldsArray], ['status', 'connection', 'lastSyncAt']) {
    status?: ErpSyncStatus;
    connection?: string;
}
